{
  "invalid_phone_number": "Please enter a valid phone number",
  "indian_phone_number_digits_limit": "Please enter a 10 digit phone number",
  "serviceability_error": "Selected address is not serviceable. Please change address.",
  "indian_phone_required_for_indian_address": "Indian (+91) phone number is required for delivery.",
  "save_value": "Save {{discount}} • ",
  "flat_value": "Flat {{discount}} ",
  "prepaid_percentage": "Extra {{value}}% discount on all online payments!",
  "prepaid_percentage_with_limit": "Extra {{value}}% off upto ₹{{limit}} on online payments!",
  "prepaid_fixed_amount": "off on all online payments!",
  "address_header": "Select address",
  "add_new_address_button": "Add new address",
  "add_new_address_header": "Add new address",
  "review_address_header": "Review Address Details",
  "confirm": "Confirm",
  "choose_option": "Choose Option",
  "search_variants_field": "Search by name, variant...",
  "no_variants_found": "No variants found!",
  "cancel": "Cancel",
  "exit_checkout": "EXIT CHECKOUT",
  "search_address_field": "Search for an area, street name...",
  "add_change_address": "Add or Change address",
  "delivering_to_address": "Delivery",
  "default_address": "Default Address",
  "billing_gst": "Billing & GSTIN",
  "suggestions": "SUGGESTIONS",
  "address1": "Address",
  "address2": "Locality",
  "address_pincode": "Pincode",
  "address_city": "City",
  "address_state": "State",
  "address_country": "Country",
  "address_contact_details": "Personal details",
  "save_as": "Save as",
  "recipient": "Recipient",
  "confirm_address": "Confirm Address",
  "confirm_email": "Confirm Email",
  "full_name": "Full Name",
  "phone_number": "Phone number",
  "email": "Email",
  "home": "Home",
  "work": "Work",
  "other": "Other",
  "save_address_as": "Save address as",
  "clear_form": "Clear form",
  "continue_shopping": "Shop Now",
  "order_placed_success_header": "Your order has been placed successfully.",
  "order_placed_success_description": "You’ll receive an email when your order is ready.",
  "order_placed_success_footer": "If you haven’t been redirected yet",
  "order_id_with_number": "Order {{id}}",
  "payment_success_order_status_waiting_description": "Thanks for shopping with us! Please wait while we update your order status.",
  "order_id": "Order ID",
  "continue_with_phone": "Continue with phone",
  "request_otp": "Request OTP",
  "continue": "Continue",
  "submit": "Submit",
  "india_code": "+91",
  "otp_notify": "You'll receive a 4 digit code to verify next",
  "verify_otp_header": "Enter OTP sent to",
  "verify_otp_desc": "OTP sent to +91-9123456789",
  "resend_otp_timer": "Resend OTP in",
  "resend_otp_via": "Resend OTP via",
  "resend_otp": "Resend OTP",
  "skip_otp": "Skip OTP",
  "enter_otp": "_     _      _     _",
  "verify": "VERIFY",
  "payment": "Payment",
  "popular_methods": "UPI Apps",
  "phone_pe": "PhonePe",
  "gpay": "GPay",
  "paytm": "Paytm",
  "upi_others": "More",
  "all_payment_methods": "Payment methods",
  "card_payment_header": "Debit/Credit cards",
  "card_payment_subheader": "Visa, Mastercard, RuPay",
  "upi_payment_header": "Pay via UPI",
  "upi_payment_subheader": "Enter your UPI ID",
  "upi_payment_subheader_apps_collect": "Any UPI app or UPI ID",
  "upi_payment_subheader_intent": "Quick pay through UPI apps",
  "wallets_payment_header": "Wallets",
  "wallets_payment_subheader": "PhonePe, PayZapp, PayPal",
  "netbanking_payment_header": "Netbanking",
  "netbanking_payment_subheader": "Choose from leading banks",
  "cod_payment_header": "Cash on delivery",
  "cod_payment_subheader": "Pay in cash at delivery",
  "emi_payment_header": "EMIs",
  "emi_payment_subheader": "Convert bills into EMIs",
  "pay_later_payment_header": "Pay later",
  "pay_later_payment_subheader": "Buy now, clear dues later",
  "upi_payment_dialog_header": "Add UPI ID",
  "loyalty_payment_header": "Redeem store credits",
  "loyalty_payment_subheader": "Use loyalty points",
  "aitelmoney": "Airtel Money",
  "freecharge": "Freecharge",
  "mobikwik": "Mobikwik",
  "olamoney": "Ola Money",
  "jiomoney": "Jio Money",
  "payzapp": "PayZapp",
  "select_bank": "Select a different bank",
  "find_bank": "Find a bank",
  "sbi_bank": "SBI",
  "axis_bank": "Axis",
  "icici_bank": "ICICI",
  "hdfc_bank": "HDFC",
  "kotak_bank": "Kotak",
  "yes_bank": "Yes Bank",
  "subtotal": "Subtotal",
  "discount": "Coupon discount",
  "gift_card": "Gift card",
  "shipping": "Shipping",
  "to_pay": "To Pay",
  "free_shipping": "free",
  "total": "Total",
  "tax": "Tax",
  "preferred_methods": "Preferred payment methods",
  "secured": "Secured",
  "card_number": "Card number",
  "expiry": "Expiry (MM/YY)",
  "cvv": "CVV",
  "card_name": "Name on card",
  "save_card": "Securely save card details",
  "upi_placeholder": "Enter your UPI ID",
  "save_upi": "Securely save your UPI ID",
  "cancel_payment": "Cancel Payment",
  "payment_initializing": "Your payment is initializing",
  "payment_processing": "Processing your payment...",
  "payment_processing_upi": "Please accept the payment request on your UPI app",
  "payment_failed_retry": "Your payment has failed. Please try again.",
  "payment_cancellation_failed": "Payment cancellation failed. Please try again.",
  "verifying_vpa": "Verifying your VPA",
  "apply_coupons": "Apply coupon",
  "view_order_summary": "View order summary",
  "enter_coupon_code": "Enter coupon code",
  "available_coupons": "Available coupons",
  "apply_btn": "Apply",
  "offer_applied_desc": "You saved",
  "placing_order": "Your order is being placed",
  "placing_order_wait": "Payment successful. Your order is being placed.",
  "phone_number_logout": "Not you? Log in with another phone number",
  "more_saved_method": "+ More saved methods",
  "more": "View more",
  "coupon_not_found": "Coupon code is not applicable",
  "address_type_exists": "{{type}} already exists",
  "upi_required": "Please enter a UPI ID",
  "invalid_upi": "Please enter a valid UPI ID",
  "add_address_failed": "Error occured while adding address. Please try again.",
  "address_delete_failed": "Error occured while deleting address. Please try again.",
  "address_delete_success": "Address deleted successfully",
  "confirm_address_delete_header": "Delete address",
  "confirm_address_delete_desc": "Are you sure you want to delete this address?",
  "cod_mode_extra_charge": "Extra ₹{{price}} will be charged",
  "cod_confirmation_popup_header": "Confirm Cash on Delivery",
  "cod_confirmation_popup_desc": "Please confirm your COD order of ₹{{price}}",
  "including_charges": "(including COD charges)",
  "pay_online_save_x": "Pay online (save ₹{{price}})",
  "pay_online_save_upto_x": "Pay online (save upto ₹{{price}})",
  "pay_online_x_save_y": "Pay online {{payment}} (Save {{off}})",
  "pay_online": "Pay online",
  "marketing_user_consent": "Keep me posted about sales and offers",
  "marketing_user_consent_v2": "Keep me posted about offers via SMS, email & WhatsApp",
  "marketing_user_consent_v3": "Notify me for any updates/offers using RCS/WABA & SMS",
  "terms_and_conditions": "Terms",
  "terms_and_conditions_loyalty": "Terms and Conditions",
  "email_collect_dialog_header": "Enter your email address to continue",
  "invalid_zip": "Invalid pincode",
  "invalid_email": "Invalid Email ID",
  "invalid_phone": "Invalid phone number",
  "required_fields": "Please fill the required fields",
  "cancel_checkout_header": "Cancel order?",
  "cancel_checkout": "All progress will be lost and the order will not be completed.",
  "card_network_error": "Card network is not supported at the moment",
  "enter_phone_to_checkout": "Enter your phone number to checkout",
  "item_total": "Item total",
  "prepaid_discount": "Prepaid discount",
  "grand_total": "Grand total",
  "logged_in_as": "Logged in with ",
  "discounts_whoops_title": "Whoops.",
  "discounts_whoops_description": "This discount code is not available to you right now",
  "discount_hurray": "Hurray!",
  "discount_saved_on_order": "Saved on your order",
  "discount_applied": "has been successfully applied!",
  "saving_strip_1": "Congrats, you have saved ₹",
  "saving_strip_2": "on this order!",
  "proceed_to_pay": "Proceed to Pay",
  "pay": "Pay",
  "notify_on_updates": "Notify me about order updates & offers",
  "all_banks": "All Banks",
  "by_continuing_text": "By continuing, you agree to our",
  "privacy_policy": "Privacy Policy",
  "enter_code_send_to_phone": "Enter the code sent to your phone number",
  "otp_expired": "Your code has expired!",
  "otp_incorrect": "Please enter the correct OTP to proceed",
  "enter_your_otp": "Please enter your OTP",
  "change": "Change",
  "redeem": "Redeem",
  "enter_all_fields": "Enter all the required fields",
  "edit_address": "Edit address",
  "address_not_selected": "Please select an address to continue",
  "valid_card_number": "Please enter a valid card number",
  "valid_expiry_date": "Please enter expiry date",
  "valid_cvv": "Please enter your cvv",
  "valid_card_name": "Please enter your name on card",
  "country_region": "Country/Region",
  "gstin": "GSTIN",
  "gst_business_name": "Business Name",
  "valid_gstin": "Please enter a valid GSTIN",
  "gstin_required": "Please enter a GSTIN",
  "gst_business_name_required": "Please enter GST business name",
  "emoji_validation": "Emojis are not allowed",
  "address": "Address",
  "primary_button_text_back_confirm": "Yes, cancel",
  "secondary_button_text_back_confirm": "No",
  "cod_confirm_text": "Confirm your COD order",
  "skip_verificaiton": "Skip Verification",
  "order_in_time_statement": "We’d love to make sure that you get your order in time 💫",
  "number_used_for_comms": "Number will be used for delivery communications",
  "payment_mode_header_others": "Others",
  "snapmint_payment_header": "Snapmint",
  "snapmint_payment_subheader": "0% EMI • No card required",
  "velocity_payment_header": "Velocity",
  "velocity_payment_subheader": "0% EMI • No card required",
  "simpl_payment_subheader": "Split into 3 easy payments",
  "simpl_pl_payment_subheader": "Shop now, pay next month",
  "bharatx_payment_header": "BharatX",
  "bharatx_payment_subheader": "0% EMI • Card not needed",
  "payment_do_not_cancel": "Please wait as we are confirming the transaction on our end",
  "paypal": "PayPal",
  "amazonpay": "Amazon Pay",
  "address_min_character": "Please enter your complete address",
  "delete_discount_error": "Error occured while removing discount. Please try again.",
  "delete_gift_card_error": "Error occured while removing gift card. Please try again.",
  "gift_card_redeem_error": "Enter a valid gift card number and pin",
  "gift_card_error": "Error occured while redeeming gift card. Please try again.",
  "valid_pincode": "Please enter a valid pincode",
  "pincode_required": "Please enter your pincode",
  "valid_name": "Please enter minimum {{count}} characters",
  "name_required": "Please enter your name",
  "valid_address": "Please enter a valid address",
  "full_address": "Please enter your full address",
  "address_min_length": "Please enter at least {{count}} characters",
  "valid_phone_number": "Please enter a valid phone number",
  "valid_indian_phone_number": "Please enter a valid Indian phone number",
  "valid_city": "Please enter a valid city name",
  "city_letters_only": "City name can only contain letters",
  "city_required": "Please enter your city",
  "valid_state": "Please enter a valid state name",
  "state_required": "Please select your state",
  "valid_country": "Please enter a country",
  "country_code_required": "Please enter a country code",
  "address_type_required": "Please select or enter an address type",
  "valid_email": "Please enter a valid email address",
  "email_required": "Please enter your email address",
  "online_payment_header": "Pay online",
  "online_payment_subheader": "Pay with UPI/Card/Netbanking/Wallet/EMI/Paylater",
  "cred_payment_header": "CRED Pay",
  "cred_payment_subheader": "Use saved cards on CRED",
  "gift_card_payment_header": "Use gift card",
  "gift_card_payment_subheader": "Redeem card balance",
  "payment_link_header": "Pay Online",
  "payment_link_subheader": "Cards, UPI, Netbanking",
  "cashfree_payment_header": "Pay online",
  "cashfree_payment_subheader": "UPI, Cards, EMI, Wallets",
  "use_gift_card": "Use gift card",
  "use_another_gift_card": "Use another gift card",
  "automatic_freebies_free_text": "Free",
  "bank_offer_applied": "Bank offer applied",
  "shipping_handles_dialog_header": "Choose your shipping method",
  "calculated_at_next_step": "Calculated at next step",
  "replace_coupon_header_one": "Replace coupon?",
  "replace_coupon_header_other": "Replace coupons?",
  "replace_coupon_body_one": "This will remove the coupon that is currently applied. Are you sure?",
  "replace_coupon_body_other": "This will remove the coupons that are currently applied. Are you sure?",
  "celebrations_total_discounts_strip": "Total savings",
  "celebrations_total_gifts_strip": "You just got {{count}} free gifts with your purchase!",
  "celebrations_total_savings_btn_text": "Awesome",
  "delhivery_confirmation_popup_btn_text": "Tap to Change",
  "applied": "applied!",
  "cancel_checkout_header_with_savings": "You will miss out on saving",
  "cancel_checkout_body_with_savings_one": "has been applied to your order!",
  "cancel_checkout_body_with_savings_other": "have been applied to your order!",
  "stay": "Stay",
  "exit_anyway": "Exit anyway",
  "cancel_checkout_header_possible_savings": "Get your order for",
  "cancel_checkout_body_possible_savings": "Savings!",
  "order_place_failed": "Error occured while placing order. Please try again.",
  "freebie_applied_celebrations_txt": "Woohoo!",
  "freebie_applied_celebrations_desc": "Your cart has a new friend",
  "offer_applied_desc_multiple_discounts_available": "Your savings just went up",
  "multiple_automatic_discounts_applied": "Discounts applied!",
  "x_free_gifts": "You just got {{count}} free gifts with your purchase!",
  "free_gifts": "You just got free gifts with your purchase!",
  "free_gifts_and_savings": "You got free gifts and savings of",
  "you_are_saving": "You are saving",
  "add_address": "Add address",
  "total_items_one": "1 item",
  "total_items_other": "{{count}} items",
  "delivery_information_with_days": "Delivery information: {{days}}",
  "payments_low_success_rate": "Facing low success rate",
  "not_your_details": "Not your details?",
  "total_savings": "Total savings",
  "x_coupons_applied": "{{count}} applied",
  "order_summary": "Order summary",
  "unavailable_coupons": "Unavailable coupons",
  "bank_offers": "Bank offers",
  "save_x": "Save ₹{{price}} on this order!",
  "save_x_more": "Save ₹{{price}} more on this order!",
  "x_symbol_available_one": "{{count}}{{symbol}} coupon available",
  "x_symbol_available_other": "{{count}}{{symbol}} coupons available",
  "otp_resent": "We have sent you a new code",
  "invalid_phone_number_try_again": "Please enter a valid phone number and try again",
  "shipping_fee_updated": "Shipping fee updated.",
  "coupon_apply_success": "Coupon applied successfully!",
  "coupons": "Coupons",
  "place_order": "Place order",
  "send_via_whatsapp": "Whatsapp",
  "send_via_sms": "SMS",
  "oos_body_header": "Oh no",
  "oos_body_subheader": "Some items in your cart just went out of stock.",
  "oos_item": "Out of stock",
  "oos_cta": "Remove items and continue",
  "you_have": "You have ",
  "in_your_wallet": " in your wallet",
  "x_coins": "{{total}} {{brand}}",
  "loyalty_line1": "Loyalty points will be credited to this email",
  "loyalty_line2": "Switch accounts on the store page if this is incorrect.",
  "loyalty_info_toast": "Create an account with this email on the store page to start earning loyalty points",
  "change_amount": "Change amount",
  "redeem_x_coins": "Redeem {{total}} {{brand}}",
  "loyalty_points_credited": "Loyalty points will be credited to this email",
  "not_enough_coins": "You don’t have enough {{brand}} yet.",
  "create_loyalty_account": "Create an account with this email on the store page to start earning loyalty points",
  "maximum_coins": "(Maximum)",
  "loyalty_loading_text": "Preparing your rewards...",
  "change_payment_method": "Try another payment method",
  "convert_to_cod": "Cash on delivery",
  "send_whatsapp_link": "Send Whatsapp link",
  "retry_payment": "Retry Payment",
  "payment_x_failed": "Payment failed",
  "payment_error_generic": "Payment initiation failed",
  "amount_deducted_failed_warning": "If the amount was deducted, it will be automatically refunded to you within 5-7 business days.",
  "amount_deducted_cancelled_warning": "If any amount was deducted, it will be refunded to you within 5-7 business days.",
  "place_order_again": "Try placing order again",
  "wait_for_order_confirmation": "Wait for order confirmation (Close)",
  "polling_ended_message": "Didn’t catch that",
  "cancel_payment_header": "Are you sure you want to cancel the payment?",
  "yes": "Yes",
  "no": "No",
  "yes_exit": "Yes, exit",
  "exit_checkout_header": "Exit checkout?",
  "exit_checkout_subheader": "All progress will be lost and the order will not be completed.",
  "payment_cancelled": "Payment cancelled",
  "number_linked_wallet": "Number linked to your wallet",
  "not_enough_credits": "You don’t have enough store credits",
  "max_usable_x_coins": "Max usable: {{total}} ",
  "default_wallet_currency": "store credits",
  "no_wallet_line1": " You will earn upto",
  "no_wallet_line2": "that can be used towards your next purchase!",
  "paypal_payment_header": "PayPal",
  "paypal_payment_subheader": "For global transactions",
  "extra_x_off_pay_only_y": "Extra {{discount}} off · Pay only {{amount}}",
  "free_gifts_pay_only_y": "Get free gifts · Pay only {{amount}}",
  "cod_pay_x": "Place COD order for {{amount}}",
  "prepaid_discount_text": "Save upto {{discount}} when you pay!",
  "change_email": "Change email",
  "use_this_email": "Use this email",
  "enter_new_email": "Enter a new email",
  "otp_fetch_failed": "Error occured while sending OTP. Please try again.",
  "gst_fields_toggle": "I have a GST Number",
  "discount_on_mrp": "Discount on MRP",
  "gst_info_text_billing_form": "To include GSTIN, edit your delivery address.",
  "invalid_gstin_error": "Invalid GSTIN",
  "invalid_gstin": "Please enter a valid GSTIN",
  "invalid_gstin_state_code": "State for the GST is incorrect.",
  "optional_text": "Optional",
  "billing_address_gst": "Billing Address & GSTIN",
  "billing_address_header": "Billing Address",
  "convenience_fee": "Convenience Fee",
  "same_as_delivery_address": "Same as delivery address",
  "remove_item_dialog_header": "Remove item?",
  "remove_item_dialog_desc": "Are you sure you want to remove {{item_name}}?",
  "remove_item_dialog_cta": "Yes, remove",
  "remove_last_item_dialog_cta": "Remove and go back to store",
  "remove_last_cart_item_dialog_cta": "Close cart, back to store.",
  "and": "&",
  "payment_mode_not_available": "Not available for your purchase",
  "payment_mode_not_available_shipping_blocker": "Tap to change shipping method to pay via {{mode_title}}",
  "payment_mode_not_available_discount_blocker": "Some offers will be removed",
  "order_updated_toaster": "Your order has been updated.",
  "loading_coupons": "Loading coupons...",
  "cart_value": "Cart value",
  "save_and_continue": "Save and continue",
  "logout_dialog_header": "Are you sure you want to log out?",
  "logout_dialog_info": "Addresses saved via shopflo and offers linked to {{phone}} cannot be used if you log out.",
  "logout_dialog_footer": "How are my addresses linked?",
  "logout_confirmation_dialog_header": "Hey there! 👋🏼",
  "logout_confirmation_dialog_info1": "Shopflo checkout allows you to have your addresses and information across 200 brands, linked to your phone number.",
  "logout_confirmation_dialog_info2": "Your information is protected by OTP and visible only to you on your trusted devices.",
  "logout_confirmation_dialog_footer": "Privacy policy",
  "yes_logout": "Yes, logout",
  "okay": "Okay",
  "logout": "Log out",
  "keep_logged_in": "Keep me logged in on shopflo checkouts",
  "save_address_checkout": "Save this address across Shopflo checkouts",
  "otp_incorrect_login": "Please enter the correct OTP to fetch saved addresses",
  "otp_incorrect_login_sso": "Please enter the correct OTP",
  "sso_login_header": "Sign in to {{merchant_name}} with Shopflo",
  "otp_sent_title": "We've sent you an OTP",
  "otp_sent_to_label": "OTP sent to :",
  "brand_personal_data_consent": "wants to access your Shopflo account linked to:",
  "sso_personal_data_address_consent": "Fetch my addresses from Shopflo",
  "sso_personal_data_collect": "Add account details for ",
  "sso_personal_data_email_consent": "Add name and email to continue",
  "sso_link_profile_title": "Link your profile to this store",
  "sso_link_profile_subtitle": "We'll use this to save your orders and updates.",
  "free_gift": "Free gift",
  "free_gift_amount": "Free gift worth {{amount}}",
  "freebie_gift": "Freebie worth {{amount}}",
  "why_cancel_question": "Why do you want to cancel?",
  "skip": "Skip",
  "select_reason": "Please select a reason",
  "gst_form_note": "Note: Please ensure that you enter the correct details to avail the GST credit. Tax invoice will not be revised for incorrect GSTIN, incorrect address etc. ",
  "local_delivery_phone_number": "LOCAL DELIVERY PHONE NUMBER",
  "sso_bad_request": "The link you're trying to access is either expired or invalid.",
  "pay_x_amount": "Pay {{amount}}",
  "x_amount_off": "{{amount}} off",
  "split_cod_pay_amount": "Pay {{current_amount}} online + {{cod_amount}} COD",
  "pay_x_amount_now": "Pay {{amount}} now",
  "pay_x_amount_online": "Pay {{amount}} online",
  "pay_x_amount_on_delivery": "Pay {{amount}} on delivery",
  "other_methods": "Other Methods",
  "unavailable_methods": "Unavailable Methods",
  "multiple_other_methods_desc": "Some methods are not available",
  "rewards_tile_header": "Rewards",
  "rewards_earn_x_coins_info": "You will earn upto {{total_coins}} {{coin_name}} that can be used towards your next purchase!",
  "remove_offers_pay": "Remove offers and Pay",
  "remove_offers": "Remove offers",
  "select_shipping": "Select shipping ",
  "choose_another_shipping": "Choose another shipping method",
  "offers_removed_count_one": "1 offer will be removed",
  "offers_removed_count_other": "{{count}} offers will be removed",
  "include_cod_charges": "Includes {{amount}} COD fee",
  "include_additional_charges_in_percentage": "Incl. {{amount}}% fee",
  "include_additional_charges": "Incl. {{amount}} fee",
  "select_cod_option": "Cash on delivery options",
  "split_payment_online_and_cod": "Split payments in online and COD",
  "include_cod_fee": "Incl. COD fee of ₹{{amount}}",
  "include_cod_fee_in_percentage": "Incl. {{amount}}% COD fee",
  "pay_using_online": "Pay using online payment methods",
  "free_cod": "FREE COD",
  "upto_x_discount": "Upto {{amount}} discount",
  "x_prepaid_discount": "{{amount}} prepaid discount",
  "confirm_payment_method": "Confirm payment method",
  "confirm_cod_order_of_x": "Confirm COD order of {{amount}}",
  "order_increased_x": "Order total increased to {{amount}}",
  "place_cod_order": "Place COD order",
  "total_order_increased_description": "The total payable amount has changed for your chosen payment method. Are you sure you want to proceed?",
  "order_total_will_increase": "Order total will increase to {{amount}}",
  "order_total_will_be_increased": "Order total will be increased",
  "payment_method_unavailable_for_offers": "Selected payment method cannot be combined with some offers.",
  "pay_with_offers": "Pay with offers",
  "pay_x_with_offers": "Pay {{amount}} with offers",
  "confirm_cod_order_for_x": "Confirm COD order for {{amount}}",
  "enter_otp_to_place_order": "Please enter the correct OTP to place your order",
  "order_delivery_time_info": "We’d love to make sure that you get your order in time 💫",
  "cod_otp_footer_message": "We’d love to make sure that you get your order in time 💫",
  "cart_is_empty": "Nothing in your cart!",
  "cart_is_empty_subtitle": "Browse our collection and products",
  "your_cart": "Your Cart",
  "apply_offer": "Apply Offer",
  "leave_checkout": "Leave Checkout",
  "wait": "Wait!",
  "off": "off",
  "offer_still_there": "Offer is still there!",
  "apply_coupon_before_exiting": "Apply available coupon before exiting",
  "about_to_lose_savings": "You're about to lose",
  "in_savings": "in savings!",
  "skip_and_exit": "Skip & Exit",
  "exit_checkout_confirm_header": "Exit checkout?",
  "exit_checkout_confirm_body": "Your cart will be saved. Are you sure you want to leave checkout?",
  "stay_in_checkout": "Stay in Checkout",
  "reason_optional": "Reason (Optional)",
  "why_leaving": "Why are you leaving?",
  "submit_feedback": "Submit Feedback",
  "reason_placeholder": "Tell us more...",
  "please_select_reason": "Please select at least one reason before submitting.",
  "verify_otp": "Verify with OTP",
  "enter_otp_to_verify": "Enter OTP sent to verify ",
  "add_note": "Add a note",
  "order_note": "Order note",
  "edit": "Edit",
  "save": "Save",
  "n_items": "{{items}} items",
  "estimated_total": "Estimated total",
  "bill_summary": "Bill summary",
  "cart_total": "Cart total",
  "delivery_fee": "Delivery fee",
  "upsell_loading_text": "Preparing your products...",
  "add": "Add",
  "unable_to_add": "Unable to add product(s) to your cart",
  "you_might_also_like": "You might also like",
  "additional_offers": "Additional offers",
  "upsell_product_added": "Product has been added to cart",
  "upsell_multiple_product_added": "Products have been added to cart",
  "show_details": "Show details",
  "confirm_your_payment_method": "Confirm your payment method",
  "pay_online_x": "Pay online {{amount}}",
  "to_be_calculated": "To be calculated",
  "use_x_coins_worth_amount": "Use {{coins}} {{coin_name}} worth {{amount}}",
  "use_upto_x_coins": "Use upto 15,000 of 3,79,718 Blisscoins in your wallet",
  "wallet_balance": "Wallet balance",
  "max_usable": "Max usable",
  "earn": "Earn",
  "x_coins_worth_amount": "{{coins}} {{coinName}} worth {{amount}}",
  "redeem_points_on_next_order": "Redeem points on your next order",
  "snapmint_waiting_message": "Your payment via Snapmint has been initiated. Once we get a confirmation, your order will be placed.",
  "velocity_waiting_message": "Your payment via Velocity has been initiated. Once we get a confirmation, your order will be placed.",
  "otp_limit_exceeded": "OTP limit exceeded",
  "how_we_secure_info": "Here’s how we secure your information",
  "sign_in_to_merchant": "Sign in to {{merchant}}",
  "sso_user_greeting": "Hello, {{user}}",
  "data_protection": "Data protection",
  "data_protection_note": "Shopflo does not share any data with brands without your consent. You can review and change your account information anytime by editing the phone number and email",
  "mobile_verification": "Mobile verification",
  "mobile_verification_note": "You are protected with OTP authentication designed to ensure that you are the only person who can access your information.",
  "unlocked": "UNLOCKED!",
  "sso_not_user_header": "Log out of {{phone}}?",
  "sso_not_user_desc": "If your name or email seems to be incorrect, you can update your account information for this number.",
  "sso_edit_account": "Edit account information",
  "cashback_amount": "Flat ₹{{amount}} cashback on this order",
  "claim_cred_cashback": "Claim cashback on CRED app after completing your purchase",
  "cred_reward_header": "Cashback on CRED",
  "ticker_tape_gold_amount": "₹{{amount}} free digital gold on Tickertape",
  "ticker_tape_reward_header": "Free Digital Gold",
  "claim_ticker_tape_cashback": "Claim Free Digital Gold on Tickertape after completing the purchase.",
  "link_expired": "Link expired!",
  "link_expired_description": "The offer you are trying to access was available for a limited period and is no longer active.",
  "earn_x_cashback_with_purchase": "Earn {{amount}} cashback with this purchase",
  "x_off_on_next_order": "{{amount}} off on your next order",
  "deliver_to": "Deliver to",
  "delivery_information": "Delivery information",
  "view_location": "View location",
  "invalid_location_value": "Invalid values to be located",
  "download_file": "Download file",
  "uploaded_file": "Uploaded File",
  "best_offers": "Best offers",
  "offers_and_rewards": "Offers & Rewards",
  "you_have_x_coins": "You have {{total}} {{brand}}",
  "order_total": "Order total",
  "delivery": "Delivery",
  "x_field_missing_form_address": "{{field}} is missing from selected address",
  "change_address": "Change address",
  "pincode_not_serviceable": "Pincode is not serviceable",
  "pincode_not_serviceable_item_in_cart": "Pincode unservicable for items in your cart",
  "switch_discount_codes_header": "Would you like to switch to a different discount?",
  "yes_replace": "Yes, replace",
  "keep_existing_discounts": "Keep existing discounts",
  "cannot_combine_coupons": "{{invalid_coupons}} cannot be combined with {{applied_coupon}}",
  "replacing_coupons": "Replacing Coupons",
  "replace_reward_header": "Would you like to switch to a different offer?",
  "keep_existing_rewards": "Keep existing rewards",
  "cannot_combine_rewards": "{{invalid_items}} cannot be combined with {{applied_item}}",
  "will_be_replaced_by": "{{invalid_coupons}} will be replaced by {{applied_coupon}}",
  "confirm_rewards_application": "Would you like to switch to a different offer?",
  "shopify_gift_card_error": "Error while applying Gift Card",
  "payment_methods": "Payment methods",
  "remove": "Remove",
  "x_coupons_available": "{{count}}{{symbol}} coupons available",
  "view_all_coupons": "View all coupons",
  "apply": "Apply",
  "add_items": "Add Items",
  "rewards": "Rewards",
  "use_available_coins": "Use available {{name}}",
  "pay_online_and_save_more": "Pay online & Save more",
  "pay_online_and_skip_cod_charge": "Pay online and save on COD charges",
  "earn_x_pop_coins_worth_y": "Earn {{x}} PoPcoins worth ₹{{y}}",
  "redeem_on_next_purchase": "Redeem on your next purchase",
  "failed_to_replace_coupons": "Failed to replace coupons",
  "failed_to_fetch_upsells": "Failed to fetch upsells",
  "popcoins": "PoPcoins",
  "address_fetch_error": "Error fetching ETD",
  "invalid_user": "Invalid user login!",
  "invalid_user_description": "The link you are trying to access is associated with a different phone number. Please check the number or try again with the correct one.",
  "whatsapp_session_expired": "Request expired. Please try again",
  "whatsapp_login_error": "Request expired. Please try again.",
  "whatsapp_login": "Login via Whatsapp",
  "enter_a_coupon_code": "Enter a coupon code",
  "view_other_coupons": "View other coupons",
  "savings": "savings",
  "coupon_applied": "Applied",
  "select_any_x": "Select any {{x}}",
  "select_any_x_from_below_y_items": "Select any {{x}} from below {{y}} items",
  "select_items": "Select items",
  "view": "View",
  "get_a_freebie_on_purchase": "Get a freebie with your order",
  "get_x_freebies_on_purchase": "Get {{x}} freebies with your order",
  "get_a_discounted_product_on_purchase": "Get a discounted product with your order",
  "get_x_discounted_products_on_purchase": "Get {{x}} discounted products with your order",
  "get_a_freebie_and_a_discounted_product_on_purchase": "Get a freebie and a discounted product with your order",
  "get_x_freebies_and_y_discounted_products_on_purchase": "Get {{x}} freebies and {{y}} discounted products with your order",
  "get_x_freebies_and_a_discounted_product_on_purchase": "Get {{x}} freebies and a discounted product with your order",
  "get_a_freebie_and_x_discounted_products_on_purchase": "Get a freebie and {{x}} discounted products with your order",
  "free_gift_unlocked": "You’ve unlocked a freebie",
  "free_gifts_unlocked": "You’ve unlocked freebies",
  "discounted_product_unlocked": "You’ve unlocked a discounted product",
  "discounted_products_unlocked": "You’ve unlocked discounted products",
  "x_out_of_y_selected": "{{x}}/{{y}} Selected",
  "logging_you_in": "Logging you in...",
  "fetching_best_offers": "Fetching best offers...",
  "almost_there": "Almost there...",
  "now": "Now",
  "in_x_months": "in {{months}} EMIs",
  "add_to_wishlist": "Add to wishlist",
  "save_for_later": "Save for later",
  "added_to_wishlist": "Added to wishlist",
  "removed_from_wishlist": "Removed from wishlist",
  "error_adding_to_wishlist": "Error adding to wishlist",
  "error_removing_from_wishlist": "Error removing from wishlist",
  "login_to_add_to_wishlist": "Please login to add items to wishlist",
  "wishlist": "Wishlist",
  "your_wishlist": "Your wishlist",
  "store_logged_out_error": "User is not logged in on store.",
  "rupees_redeemable": "₹{{amount}} redeemable",
  "rupees_redeemed": "₹{{amount}} redeemed",
  "your_coin_name_points_balance": "Your {{coinName}} balance",
  "balance_label": "{{coins}} Balance :",
  "max_usable_label": "Max usable {{coins}}:",
  "earn_x_coins_worth_y_on_this_order": "Earn {{x}} {{coin}} worth ₹{{y}} on this order",
  "verify_phone_number_to_place_order": "Verify your phone number to place an order",
  "error_screen_title": "Uh-oh!",
  "error_screen_description": "Something went wrong. Don't worry, our team is on it! You can try again or check back in a little while.",
  "error_screen_btn_title": "Retry",
  "something_went_wrong": "Something went wrong",
  "includes_additional_charges": "Includes additional charges",
  "includes_charges": "Incl. charges",
  "add_items_worth_delivery": "Add items worth {{amount}} more to be eligible for delivery",
  "item_in_cannot_be_delivered": "Items in your cart cannot be delivered",
  "item_unservicable_on_pincode_one": "{{count}} item cannot be delivered to your address {{pincode}}",
  "item_unservicable_on_pincode_other": "{{count}} items cannot be delivered to your address {{pincode}}",
  "go_back_to_store": "Go back to store",
  "have_a_gift_voucher_or_epay": "Have a Gift Voucher / EPAY?",
  "powered_by_gyftr": "Powered by Gyftr",
  "gift_voucher_or_epay": "Gift vouchers / EPAY",
  "add_gift_voucher_to_epay": "Add gift voucher to EPAY",
  "add_more": "Add more",
  "gift_voucher_balance": "Gift Voucher / EPAY balance",
  "enter_amount_to_redeem": "Enter amount to redeem",
  "have_more_gift_vouchers": "Have more gift vouchers?",
  "gv_or_epay_balance": "Gift Voucher / EPAY balance: ₹{{amount}}",
  "remaining_balance": "Remaining EPAY balance: ₹{{amount}}",
  "epay_balance_applied": "Gift & Voucher applied",
  "gift_voucher_balance_remaining": "Gift voucher balance: ₹{{amount}}",
  "redeem_x_gift_card": "Redeem {{total}} gift points",
  "pay_x_now_and_y_on_delivery_tag": "{{amount}} now + {{cod_amount}} COD",
  "split_cod_payment_header": "Partial COD",
  "split_cod_payment_subheader": "Pay part online, rest later",
  "view_more": "View more",
  "item_details": "Item details",
  "remove_unservicable_items": "Remove items",
  "remove_items": "Do you want to remove {{item_count}}?",
  "gift_voucher": "Gift Voucher",
  "rupees_applied": "₹{{amount}} applied",
  "pay_x_now_and_y_on_delivery_header": "Pay {{amount}} online and {{cod_amount}} on delivery",
  "recently_viewed": "You recently viewed",
  "delivery_address": "Delivery Address",
  "friends_slash_family": "Friends",
  "no_saved_addresses": "No saved addresses",
  "cart_note_error": "Note can't be empty",
  "error_saving_note": "Something went wrong while saving your note",
  "combined_products_removal_dialog_header": "Remove items?",
  "combined_products_removal_dialog_items_cannot_be_purchased_one": "This item cannot be purchased without",
  "combined_products_removal_dialog_items_cannot_be_purchased_other": "These items cannot be purchased without",
  "combined_products_removal_dialog_items_will_be_removed_one": "The item shown below will be removed",
  "combined_products_removal_dialog_items_will_be_removed_other": "The items shown below will be removed",
  "combined_products_removal_dialog_maintain_offer_integrity": "from your cart to maintain offer integrity.",
  "keep_existing": "Keep existing items",
  "upi_description_desktop": "Scan and Pay via UPI apps",
  "upi_description_mobile": "UPI",
  "suggested_apps": "Suggested apps",
  "other_apps": "Other apps",
  "close_preview": "Close preview",
  "copy_preview_link": "Copy preview link",
  "total_items": "{{count}} item",
  "total_items_plural": "{{count}} items",
  "max_length_exceeded": "Cannot exceed {{limit}} characters.",
  "coupons_length": "+{{count}} more offers",
  "have_any_gc": "Have any gift card",
  "use_epay": "Use GyFTR ePay voucher?",
  "gc_instant_savings": "Apply Shopify Gift Card for instant savings.",
  "save_more_gc": "Save more with Gift Card!",
  "gc_applied": "Gift card applied!",
  "use_max": "Use max",
  "gyftr_balance": " available",
  "gyftr_savings": "Apply GyFTR ePay for instant savings.",
  "save_more_gyftr": "Save more with GyFTR ePay!",
  "saved_with_discounts": "Saved with discounts!",
  "e_pay_voucher_applied": "ePay applied!",
  "gift_card_balance": "Gift card balance",
  "add_balance": "Add balance",
  "gyftr_e_pay_balance": "GyFTR e-Pay balance",
  "redeem_epay_voucher": "Redeem ePay voucher",
  "view_coupons": "View Coupons",
  "shipping_discount_available": "Discount available on all rates!",
  "saved": "Saved",
  "cod_available": "COD available",
  "plus_extra_charges": "+ Extra charges",
  "cod_only": "COD only",
  "shipping_discount_applied": "Shipping discount applied",
  "reveal_offer": "Reveal offer",
  "more_offers": "More offers",
  "invalid_address_url": "Address cannot contain URL links",
  "invalid_address": "Please enter a valid address",
  "english_only": "Please use only English characters",
  "split_cod_available": "Split COD available",
  "split_cod_only": "Split COD only",
  "start_typing_suggestions": "Start typing for suggestions...",
  "payment_initiate_failed": "Payment initiate failed",
  "profile_sign_in_subtitle": "Sign in to manage how stores know you",
  "profile_phone_placeholder": "Phone Number",
  "profile_send_otp_loading": "Sending...",
  "profile_verify_otp_loading": "Verifying...",
  "profile_otp_send_hint": "We'll send you an OTP to verify",
  "profile_resend_otp_in": "Resend OTP in {{time}}",
  "profile_emails_load_error": "We couldn't load your email settings right now.",
  "profile_toast_login_email_removed_success": "Login email removed successfully.",
  "profile_toast_email_removed_success": "Email removed successfully.",
  "profile_error_remove_login_email": "We couldn't remove your login email.",
  "profile_error_remove_email": "We couldn't remove this email.",
  "profile_toast_default_login_email_updated": "Default login email updated successfully.",
  "profile_error_update_default_login_email": "We couldn't update your default login email.",
  "profile_delete_email_title_primary": "Remove login email?",
  "profile_delete_email_title_secondary": "Remove email?",
  "profile_delete_email_desc_primary": "{{email}} will no longer be your default login email.",
  "profile_delete_email_desc_secondary": "{{email}} will be removed from your account.",
  "profile_delete_confirm_loading": "Removing...",
  "profile_delete_email_keep": "Keep email",
  "profile_emails_header": "Login Emails",
  "profile_emails_subtitle": "Set your login email for Shopflo-powered stores",
  "profile_emails_add_new": "Add new email",
  "profile_emails_loading": "Loading emails...",
  "profile_emails_empty": "No login emails found.",
  "profile_emails_current_login": "Current login email",
  "profile_emails_set_as_login": "Set as login email",
  "profile_emails_delete": "Delete",
  "profile_toast_profile_updated_success": "Profile updated successfully.",
  "profile_email_dialog_title_new": "New Email",
  "profile_email_dialog_title_edit": "Edit Email",
  "profile_email_next_verify": "Next, Verify",
  "profile_email_verify_save": "Verify & Save",
  "profile_email_preferred_toggle": "Use this as preferred login email",
  "profile_email_preferred_toggle_hint": "You'll use this to sign in to any Shopflo-powered store instead of your current email.",
  "profile_email_toast_added_and_primary": "Email added and set as your default login email.",
  "profile_email_toast_added": "Email added successfully.",
  "profile_email_toast_updated_and_primary": "Email updated and set as your default login email.",
  "profile_email_toast_updated": "Email updated successfully.",
  "profile_email_toast_verified_default": "Email verified and set as your default login email.",
  "profile_email_otp_sent_with_email": "OTP has been sent to {{email}}",
  "profile_email_a11y_enter_email": "Enter your email address",
  "profile_email_a11y_enter_otp": "Enter the OTP sent to your email",
  "profile_page_title": "Your Profile",
  "profile_page_managed_by": "Managed by Shopflo",
  "profile_back_to_store": "Back to store",
  "profile_terms_of_use": "Terms of Use",
  "profile_brand_logo_alt": "Shopflo",
  "profile_avatar_illustration_alt": "Profile avatar",
  "partner_offers": {
    "pay_online_save_more": "Pay Online & Save more",
    "miss_partner_offers_prefix": "You'll miss partner offers worth",
    "miss_partner_offers_suffix": ". Pay online to keep them.",
    "these_vouchers": "these vouchers",
    "pay_online": "Pay Online",
    "place_cod": "Enable COD",
    "place_split_cod": "Enable Split COD",
    "all_vouchers_claimed": "All vouchers claimed!",
    "claimed": "Claimed",
    "collect_all": "Collect All",
    "collected": "Collected",
    "collect": "Collect",
    "hide_details": "Hide details",
    "worth_vouchers_claimed": "{{amount}} worth vouchers claimed!",
    "x_of_y_claimed": "{{collected}}/{{total}} claimed",
    "section_title": "Partner Offers",
    "prepaid_only_notice": "Partner offers are issued only on Prepaid Orders",
    "min_order_value": "Min. order {{value}}",
    "powered_by": "Powered by"
  },
  "shopify_login": {
    "continue_as": "Continue as",
    "hey_there": "Hey There!",
    "access_as": "Access your account as",
    "verify_email": "Verify Email",
    "otp_sent_to": "OTP has been sent to",
    "incorrect_otp": "Incorrect OTP. Please try again.",
    "not_received": "Not received?",
    "resend_in": "Resend in {{counter}}s",
    "verify_and_continue": "Verify & Continue",
    "found_emails_one": "Found {{count}} email",
    "found_emails_other": "Found {{count}} emails",
    "email_scope_info": "Selected email will be used for all Shopflo-powered stores",
    "manage_emails": "Manage Emails",
    "primary_email_updated": "Primary email has been updated",
    "send_otp_failed": "Failed to send OTP. Please try again.",
    "update_email_failed": "Failed to update primary email. Please try again.",
    "generic_error": "Something went wrong. Please try again.",
    "email_verified_success": "Email verified successfully",
    "almost_there": "Almost there!",
    "add_email_subtitle": "Add your email to access your account",
    "verify_email_address": "Verify your email address",
    "email_label": "Email",
    "email_placeholder": "Enter email address",
    "email_required": "Please enter your email address.",
    "invalid_email": "Please enter a valid email address.",
    "no_email_greeting": "Hey There,",
    "no_email_subtitle": "No login email found. Add one to continue.",
    "no_email_message": "Add at least one email to your account to proceed with login.",
    "add_email": "Add Email",
    "add_and_verify": "Add & Verify"
  },
  "subscription_pay_once": "Pay Once",
  "subscription_subscribe": "Subscribe",
  "subscription_mode_tabs_label": "Choose how to pay",
  "subscription_choose_plan": "Choose Plan",
  "subscription_choose_plan_subtitle": "Pick the plan that works best for you.",
  "subscription_recommended": "Recommended",
  "subscription_more_plans": "+{{count}} more plans",
  "subscription_mode_switch_failed": "Couldn't update your order. Please try again.",
  "subscription_no_longer_available": "Subscribe & Save isn't available for this cart any more.",
  "subscription_plan_select_failed": "Couldn't select that plan. Please try again.",
  "subscription_no_payment_mode": "Subscriptions need UPI auto-pay, which isn't available on this order.",
  "subscription_switch_to_pay_once": "Pay once instead",
  "subscription_more_plans_singular": "+{{count}} more plan",
  "subscription_every": "Every",
  "subscription_for": "for",
  "subscription_until_cancelled": "until cancelled",
  "subscription_schedule_first_order": "First order will be placed {date_of_order}",
  "subscription_schedule_next_order": "Orders will be placed every {frequency} · Next on {upcoming_order}",
  "subscription_schedule_ends": "Subscription ends on {duration_date} · {delivery_count} deliveries total",
  "subscription_schedule_delivery": "Get it delivered every {frequency}",
  "subscription_interval_week_one": "week",
  "subscription_interval_week_other": "weeks",
  "subscription_interval_month_one": "month",
  "subscription_interval_month_other": "months",
  "subscription_count_with_unit": "{{count}} {{unit}}",
  "subscription_deliveries_one": "{{count}} delivery",
  "subscription_deliveries_other": "{{count}} deliveries",
  "subscription_savings_amount": "Save ₹{{amount}}",
  "subscription_discount_percentage": "{{value}}% off",
  "subscription_discount_flat": "₹{{value}} off",
  "consent_allow_cookies": "Allow cookies for analytics, ads and personalisation.",
  "consent_manage_preferences": "Manage preferences",
  "consent_preferences_title": "Pick what you’re happy to share.",
  "consent_save_preferences": "Save Preferences",
  "consent_read_more": "Read more",
  "consent_detailed_statement": "Detailed statement",
  "consent_marketing_fallback": "Keep me posted about sales and offers by Email, SMS and WhatsApp"
}
